import React, { Component } from "react";
import { Modal, DatePicker, Checkbox, Select, Alert, Input } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import moment from "moment";
import { SelectEmpleadosItem } from "../../../../Components/Items";
import { TIPOS_SERVICIO } from "../cmmsComun";
import "../cmms.css";

const { Option } = Select;

// Fecha e ingeniero para uno o varios servicios calendarizados (o para agregar un equipo
// a la agenda). Nada de esto crea la Orden de Servicio.
// onAceptar({ fecha: moment|null, quitarFecha, cambiarEmpleado, empleadoId, tipoServicio, notas })
class ModalCalendarizarCMMS extends Component {
    state = { fecha: null, quitarFecha: false, cambiarEmpleado: false, tocoEmpleado: false, empleadoId: null, tipoServicio: 1, notas: "", guardando: false };

    get enLote() {
        return (this.props.cantidad || 0) > 1;
    }

    componentDidUpdate(prev) {
        if (this.props.visible && !prev.visible) {
            this.setState({
                fecha: this.props.fechaInicial ? moment(String(this.props.fechaInicial).slice(0, 10)) : null,
                quitarFecha: false,
                cambiarEmpleado: false,
                tocoEmpleado: false,
                empleadoId: this.props.empleadoInicial || null,
                tipoServicio: this.props.tipoServicioInicial || 1,
                notas: "",
                guardando: false,
            });
        }
    }

    // El ingeniero solo se cambia si se pide: en lote con la casilla, en uno solo al tocar el
    // selector (si no, reprogramar solo la fecha borraria el ingeniero que ya tenia).
    aceptar = async () => {
        const { fecha, quitarFecha, empleadoId, tipoServicio, notas } = this.state;
        const cambiarEmpleado = this.enLote ? this.state.cambiarEmpleado : this.state.tocoEmpleado;
        this.setState({ guardando: true });
        try {
            await this.props.onAceptar({ fecha: quitarFecha ? null : fecha, quitarFecha, cambiarEmpleado, empleadoId, tipoServicio, notas });
        } finally {
            this.setState({ guardando: false });
        }
    };

    render() {
        const { visible, titulo, cantidad, permitirQuitarFecha, conTipoServicio, fechaObligatoria, rango, nota, fechaBloqueada } = this.props;
        const sinFecha = !this.state.quitarFecha && !this.state.fecha;
        const cambiaEmpleado = this.enLote ? this.state.cambiarEmpleado : this.state.tocoEmpleado;
        // Sin el permiso "Mover en la agenda" la fecha que ya tiene no se cambia: solo el ingeniero.
        const deshabilitado = fechaBloqueada ? !cambiaEmpleado : (fechaObligatoria && sinFecha) || (!fechaObligatoria && sinFecha && !cambiaEmpleado);
        return (
            <Modal
                className="cmms-modal"
                visible={visible}
                onCancel={this.props.onCancel}
                onOk={this.aceptar}
                okText="Aceptar"
                cancelText="Cancelar"
                confirmLoading={this.state.guardando}
                okButtonProps={{ disabled: deshabilitado }}
                width={window.innerWidth > 700 ? 520 : "96%"}
                title={
                    <div className="cmms-modal-titulo">
                        <CalendarOutlined style={{ fontSize: 20, color: "#2fb8d6" }} />
                        <div>
                            <div className="cmms-modal-titulo-texto">{titulo || "Calendarizar"}</div>
                            <div className="cmms-modal-subtitulo">
                                {cantidad > 1 ? `${cantidad} equipos seleccionados. ` : ""}Sólo se agenda: la Orden de Servicio se crea al realizarlo.
                            </div>
                        </div>
                    </div>
                }
            >
                <div className="cmms-modal-cuerpo" style={{ paddingBottom: 12 }}>
                    {nota ? <Alert type="info" showIcon message={nota} style={{ marginBottom: 10 }} /> : null}
                    {fechaBloqueada ? <Alert type="warning" showIcon message="No tiene permiso para mover fechas en la agenda: sólo puede cambiar el ingeniero." style={{ marginBottom: 10 }} /> : null}
                    <div className="cmms-etiqueta-campo">Fecha</div>
                    <DatePicker
                        format="DD/MM/YYYY"
                        style={{ width: "100%" }}
                        value={this.state.fecha}
                        disabled={this.state.quitarFecha || !!fechaBloqueada}
                        onChange={(fecha) => this.setState({ fecha })}
                        disabledDate={rango ? (d) => d && (d.isBefore(moment(rango[0]).startOf("day")) || d.isAfter(moment(rango[1]).endOf("day"))) : undefined}
                    />
                    {permitirQuitarFecha && !fechaBloqueada && (
                        <Checkbox style={{ marginTop: 6 }} checked={this.state.quitarFecha} onChange={(e) => this.setState({ quitarFecha: e.target.checked })}>
                            Quitar la fecha (regresa a "Por calendarizar")
                        </Checkbox>
                    )}
                    <div className="cmms-etiqueta-campo" style={{ marginTop: 12 }}>
                        {this.enLote ? (
                            <Checkbox checked={this.state.cambiarEmpleado} onChange={(e) => this.setState({ cambiarEmpleado: e.target.checked })}>
                                Cambiar el ingeniero de todos
                            </Checkbox>
                        ) : (
                            "Ingeniero"
                        )}
                    </div>
                    <SelectEmpleadosItem
                        empresaId={this.props.empresaId}
                        headersToken={this.props.headersToken}
                        width="100%"
                        allowClear
                        placeholder="Sin asignar"
                        disabled={this.enLote && !this.state.cambiarEmpleado}
                        value={this.state.empleadoId || undefined}
                        onChange={(empleadoId) => this.setState({ empleadoId: empleadoId || null, tocoEmpleado: true })}
                    />
                    {conTipoServicio && (
                        <>
                            <div className="cmms-etiqueta-campo" style={{ marginTop: 12 }}>
                                Tipo de servicio
                            </div>
                            <Select style={{ width: "100%" }} value={this.state.tipoServicio} onChange={(tipoServicio) => this.setState({ tipoServicio })}>
                                {TIPOS_SERVICIO.map((t) => (
                                    <Option key={t.value} value={t.value}>
                                        {t.label}
                                    </Option>
                                ))}
                            </Select>
                            <div className="cmms-etiqueta-campo" style={{ marginTop: 12 }}>
                                Notas
                            </div>
                            <Input.TextArea rows={2} maxLength={500} value={this.state.notas} onChange={(e) => this.setState({ notas: e.target.value })} placeholder="Opcional" />
                        </>
                    )}
                </div>
            </Modal>
        );
    }
}

export default ModalCalendarizarCMMS;
